import { Search,AccountHeadDetails } from './../../shared/user.model';
import { Component, OnInit } from '@angular/core';
import { DISABLED } from '@angular/forms/src/model';
import { Register } from '../../shared/user.model';
import { NgForm } from '@angular/forms';
//import { UserService } from '../../shared/user.service';
import { RegistrationService } from '../../registration.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import swal from 'sweetalert2';

@Component({
  selector: 'app-account-head',
  templateUrl: './account-head.component.html',
  styleUrls: ['./account-head.component.css']
})
export class AccountHeadComponent implements OnInit {
  AccountHeadDetails: any={};
  AccountHead: any;
  mode: string;
  formSubmitted: boolean;

  title="Add Account Head";  
  constructor(private router: Router,private route: ActivatedRoute,private errorHandler:ErrorHandler,private userService: RegistrationService) 
  {
    
  }

  ngOnInit() {
    //this.GetAllRegion();    
    this.route.params.subscribe(params => {
      
      this.mode = params['mode'];
      this.AccountHead = params['accountHead'];      
    });
    
    if (this.AccountHead != null && this.mode!=null) 
    {
      this.GetAccountHeadForAccountId(this.AccountHead);
    }
    if (this.mode == 'edit')
    {
      this.title = "Edit Account Head";
    }
    if (this.mode == 'view')
    {
      this.title = "View Account Head";
    }    
  }
  keyPressText(event: any) {    
    const pattern =/[A-Za-z]/;
    let inputChar = String.fromCharCode(event.charCode);
    var uname = new String(event.target.value)
    if (!pattern.test(inputChar) && uname.trim().length==0)
    {
      event.preventDefault();
    }
 } 
  keyPress(event: any) {
    debugger;
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    // console.log(inputChar, e.charCode);
    let inputChars = new Number((event.target.value + inputChar).substring(0,12));
    var element1 = <HTMLDivElement> document.getElementById("div1");
    if (inputChars==0)
    {
      //swal("Warning!","Coming Here");      
      element1.innerText="Please enter valid Account Head";
      this.formSubmitted=true;
    }
    else
    {
      element1.innerText="";
    }
    if (!pattern.test(inputChar)) 
    {       
      event.preventDefault();
    }
 }
  Reset(accountHeadForm)
  {
    accountHeadForm.reset();
  }
  GetAccountHeadForAccountId(AccountHead)
  {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAccountForAccountHead(this.AccountHead)
      .subscribe(
        (data) => {
          this.AccountHeadDetails = data;          
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  UpdateAccountHead(form)
  {
    var accountHeadText = <HTMLInputElement>document.getElementById("txtAccountHead")
    let inputChars = new Number(accountHeadText.value);
    var element1 = <HTMLDivElement> document.getElementById("div1");
    if (inputChars==0)
    {      
      element1.innerText="Please enter valid Account Head";
      form.invalid=true;
    }
    else
    {
      element1.innerText="";
    }
    if (!form.invalid) 
    {              
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.updateAccountHead(this.AccountHeadDetails).subscribe(
      (data:any) => {
        debugger;
        document.getElementById('loader-spinner').style.display = "none";
        swal('','Account Head Updated Successfully!','success');
        this.router.navigate(['/home/accounthead']);          
        }, (error) => {
          document.getElementById('loader-spinner').style.display="none";
          this.errorHandler.HandlerError(error);
        });
      }
      else
      {
        this.formSubmitted = true;
      }
  }

  Save(form)
  {
    
    var accountHeadText = <HTMLInputElement>document.getElementById("txtAccountHead")
    let inputChars = new Number(accountHeadText.value);
    var element1 = <HTMLDivElement> document.getElementById("div1");
    if (inputChars==0)
    {      
      element1.innerText="Please enter valid Account Head";
      form.invalid=true;
    }
    else
    {
      element1.innerText="";
    }

    if (!form.invalid) 
    {
      debugger;
      document.getElementById('loader-spinner').style.display = "block";
      this.userService.addAccountHead(this.AccountHeadDetails).subscribe(
      (data:any) => {
        debugger;
        document.getElementById('loader-spinner').style.display = "none";
        swal('','Account head Added Successfully!','success');
        this.router.navigate(['/home/accounthead']);
        
      }, (error) => {
        document.getElementById('loader-spinner').style.display="none";
        this.errorHandler.HandlerError(error);
      });        
    }
  
    else
    {
      this.formSubmitted = true;
    }
  }
 
}  




// WEBPACK FOOTER //
// ./src/app/Finance/account-head/account-head.component.ts